import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import "./Home.css";
import HeroSection from "../components/HeroSection";
import QualitySection from "../components/QualitySection";
import ClientCarousel from "../components/ClientCarousel";
import ServicesSection from "../components/ServicesSection";
import GetQuoteSection from "../components/GetQuoteSection";
import PortfolioSection from "../components/PortfolioSection";
import ReviewComponent from "../components/ReviewComponent";
import '../App.css'

const Home = () => {
    return (
        <div>



            <div className="content">
                <section className="w-100 below-navbar-section">
                    <Container>
                        <div className="landing-page">
                            <div className="professional-graphic-designer-parent">
                                <h1 className="professional-graphic-designer">Professional Graphic Designer at Your Service!</h1>
                                <div className="branding-experts-container">
                                    <p className="branding-experts mt-4">
                                        Branding Experts | Website Design and Development | Social Media kit <br />
                                        Logo Design | Packaging Design | Stationary Kit | IT Experts | Brand Build
                                    </p>
                                </div>
                                <div className="d-flex justify-content-center align-items-center" style={{ width: '100%', height: '100%', border: '2px black solid' }}></div>
                                <Row className="button-row mt-5 justify-content-center">
                                    <Col className="rectangle-parent2" xs={12} md={5}>
                                        <div className="group-child6"></div>
                                        <Button className="explore-services">Explore Services & Plans</Button>
                                    </Col>
                                    <Col className="rectangle-parent3" xs={12} md={5}>
                                        <div className="group-child6"></div>
                                        <Button className="explore-services">Hire us via third-PARTY</Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Container>
                </section>
            </div>
            <HeroSection/>
            <QualitySection/>
            <ClientCarousel/>
            <ServicesSection/>
            <GetQuoteSection/>
            <PortfolioSection/>
            <ReviewComponent/>
        </div>


    );

};

export default Home;
